<template>
  <div class="navbar-wrapper" v-bind:class="{ 'landing' : isLanding, 'affix' : isAffix }">

    <nav class="container navbar">
      <div class="navbar-brand">
        <router-link class="navbar-item navbar-header" to="/">
          <img src="../assets/logo.svg" width="110" class="img-responsive"
            :style="{ maxHeight: 'auto', marginRight: '30px' }" />
          <span>Lasting Impressions</span>
        </router-link>

        <div class="navbar-burger burger" data-target="nav-menu"
          @click="showNav = !showNav"
          v-bind:class="showNav ? 'is-active' : 'undefined'">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="navbar-menu" id="nav-menu"
        v-bind:class="showNav ? 'is-active' : 'undefined'">
        <div class="navbar-start">

        </div>

        <div class="navbar-end">

          <router-link class="navbar-item" :class="{ active: $route.name === 'about' }" href="#" to="about">
            About
          </router-link>

        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  // import _ from 'lodash'
  import auth from '@/apis/Auth'
  import EventBus from '@/controllers/EventBus'
  export default {
    name: 'navbar',
    data () {
      return {
        showNav: false,
        activeLink: null,
        isLanding: false,
        isAffix: false,
        scrollOffset: 200,
        scrollPos: 0 // for vue2-scrollspy
      }
    },
    computed: mapGetters([
      'isAuthenticated',
      'authenticatedUsername'
    ]),
    watch: {
      scrollPos: function (val) {
        // to make sure new scrollPos works
      }
    },
    beforeCreate () {
      // in this function
      // modification to data will not invoke
    },
    created () {
      // initial init for landing and affix (mobile/desktop)
      this.isLanding = (window.innerWidth >= 1008 && this.$route.name === 'landing')
      if (window.innerWidth < 1008) {
        this.isAffix = true
      }

      // on event change hook
      this.$router.afterHooks.push((to, from) => {
        // console.log('route change get!!')
        if (to && to.name) {
          this.isLanding = (to.name === 'landing')
        }
      })

      // on event resize
      window.addEventListener('resize', function (event) {
        // console.log('on viewport change')
        this.isLanding = (event.target.innerWidth >= 1008 && this.$route.name === 'landing')
      }.bind(this))

      window.addEventListener('scroll', function (event) {
        // console.log('on scroll')
        // console.log(event)
        if (document.body.scrollTop > this.scrollOffset ||
            document.documentElement.scrollTop > this.scrollOffset) {
          this.isAffix = true
        } else {
          this.isAffix = false
        }
      }.bind(this))
    },
    beforeMount () {
    },
    mounted () {
      EventBus.$on('scroll-pos-change', (data) => {
        if (data &&
          data.name &&
          data.name === 'landing') {
          if (data.scrollPos === 0) {
            this.scrollPos = 0
          } else if (data.scrollPos >= 1 && data.scrollPos < 3) {
            this.scrollPos = 1
          } else {
            this.scrollPos = 2
          }
        }
      })
    },
    methods: {
      logout (data) {
        auth.logout(this, (context) => {
          context.$router.push('/')
        })
      },
      onScrollTo (name, target) {
        if (this.$route.name !== name) {
          this.$router.replace({ name: name, query: { anchor: target } })
        } else {
          this.$scrollTo('#' + target)
        }
      },
      // http://redux.js.org/docs/recipes/UsingObjectSpreadOperator.html
      ...mapActions([
        'authenticated',
        'unauthenticated'
      ])
    }
  }
</script>

<style lang="scss" scoped>
@import "../assets/app_setting.scss";

.navbar {
  color: $color-black;

  @at-root nav {
    -moz-transition: all 200ms linear;
    -webkit-transition: all 200ms linear;
    -o-transition: all 200ms linear;
    transition: all 200ms linear;
  }

  @at-root &, nav#{&} {
    // background-color: $color-black;
    // position: relative;
  }

  @at-root nav#{&} {

    @at-root .landing #{&} {
      // background-color: transparent;
      // position: fixed;
      // top: 0;
      // left: 0;
      // right: 0;
      // z-index: 100;
    }

    @at-root .landing.affix #{&} {
      // background-color: black;
      // position: fixed;
    }
  }
}

.navbar {

  @media screen and (min-width: $desktop) {
    height: 110px;
  }

  &-item, &-link {
    color: $color-black;
    align-items: center;

    &.active {
      color: $color-orange;
    }

    &:hover, &.is-active {
      color: $color-orange;
      background-color: transparent;
    }

    &.has-dropdown {
      &:hover, &.is-active {
        background-color: $color-white-transparent;
        & .navbar-link {
          background-color: transparent;
          color: $color-black;
        }
      }
    }
  }
}

.navbar-dropdown {
  @media screen and (max-width: $mobile) {
    padding-top: 0;
    padding-bottom: 0;
  }

  & a {
    @media screen and (min-width: $tablet) {
      color: #202C39;
    }

    &.navbar-item:hover {
      @media screen and (min-width: $desktop) {
        color: #F0A202;
        background-color: whitesmoke;
      }
    }
  }
}

.navbar-burger {

  &:hover {
    background-color: transparent;
  }

  // & span:nth-child(1) {
  //   margin-top: -6px;
  // }
  // & span:nth-child(2) {
  //   margin-top: -2px;
  // }

  & span,
  &.is-active span,
  &.is-active:hover span {
    background-color: $color-black;
    height: 3px;
    // width: 20px;
    // margin-left: -8px;
  }
}

</style>



// WEBPACK FOOTER //
// NavBar.vue?5be147a8